module.exports = __webpack_public_path__ + "static/media/sad-face.8a824e9c.png";